// The charity mount of the ONE Social package (SMM-WEB1; Social Media Manager Module plan §SMM-8
// point 1). Mounted in EVERY build — no knob (D-SMM-9, D-SMM-14), the Donations precedent: the
// square and the pages show wherever the backend's verdict (offered + on + capability) says, so an
// organization not offered Social meets the gate's `absent`, the not-found surface.

import { SocialPage, SOCIAL_SLUG, type SocialView } from '@givmo/social';
import { ModuleGate } from '@givmo/org-console';
import { useCharityConsole } from '../../console/charity-console-context';
import { useActiveOrg } from '../../org/active-org-context';
import { useRequestAccessDoor } from '../../components/request-access-context';
import { NotFound } from '../../components/not-found';
import { useModuleNavigate } from '../../console/use-console-squares';
import { useTurnOnHref } from '../../console/use-turn-on-href';

/** The shared Social pages behind the module gate, on the page its route names. */
export function CharitySocialMount({ view }: { view: SocialView }) {
  const { pending, errored, standings, read, refetch } = useCharityConsole();
  const org = useActiveOrg();
  const door = useRequestAccessDoor();
  const navigate = useModuleNavigate();
  const turnOnHref = useTurnOnHref(SOCIAL_SLUG);
  const standing = standings?.[SOCIAL_SLUG];
  const request = standing?.accessRequest;
  return (
    <ModuleGate
      slug={SOCIAL_SLUG}
      label="Social"
      read={{ pending, errored, standings }}
      onRetry={refetch}
      renderNotFound={() => <NotFound />}
      turnOnHref={turnOnHref}
      onNavigate={navigate}
      onRequestAccess={standing?.held === true ? undefined : () => door.open(SOCIAL_SLUG)}
      accessRequest={
        request?.status === 'PENDING'
          ? { status: 'pending' }
          : request?.status === 'DENIED'
            ? { status: 'declined', note: request.resolutionNote ?? null }
            : undefined
      }
    >
      <SocialPage
        view={view}
        config={{
          orgRef: org.isReady ? org.activeCharityId : null,
          permissions: read.permissions,
          orgName: org.activeMembership?.name ?? null,
        }}
      />
    </ModuleGate>
  );
}
